
import ModuleFactory from "./utilities/module-factory";
import EventLinks from "./components/event-links";
import SpeakersSlider from "./components/speakers-slider";
import Video from "./components/video";
import Header from "./components/header";
import Agenda from "./components/agenda";
import HeroVideo from "./components/hero-video";
import ConferencesSlider from "./components/conferences-slider";
import Gallery from "./components/gallery";

const modules = [
	Agenda,
	ConferencesSlider,
	EventLinks,
	Header,
	SpeakersSlider,
	Video,
	HeroVideo,
	Gallery,
];

new ModuleFactory(modules);
